"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 个股商誉明细
 */
require("../../src/modules/slidetips");
require("../../src/modules/singlestocktop/web");
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var base_1 = __importDefault(require("./base"));
//主表配置
loadtabledata();
function loadtabledata() {
    var _a, _b, _c;
    $("#dataview_yq").emdataview({
        dataurl: {
            hostname: 'datacenter',
            url: 'api/data/v1/get',
            params: {
                columns: "ALL",
                token: '894050c76af8597a853f5b408b759f5d',
                reportName: "RPT_GOODWILL_STOCKPREDICT",
                filter: "(SECURITY_CODE=\"" + ((_a = window.stockInfo) === null || _a === void 0 ? void 0 : _a.code) + "\")(REPORT_DATE='" + ((_b = window.stockInfo) === null || _b === void 0 ? void 0 : _b.rdate) + "')"
            }
        },
        sortname: "NOTICE_DATE",
        columns: base_1["default"].columns,
        onPreBody: function (data) {
            if (data && data.length > 0) {
                $("#content_yq").show();
            }
        }
    });
    $("#dataview_mx").emdataview({
        dataurl: {
            hostname: 'datacenter',
            url: 'api/data/v1/get',
            params: {
                columns: "ALL",
                token: '894050c76af8597a853f5b408b759f5d',
                reportName: "RPT_GOODWILL_STOCKDETAILS",
                filter: "(IS_SHOW=\"1\")(SECURITY_CODE=\"" + ((_c = window.stockInfo) === null || _c === void 0 ? void 0 : _c.code) + "\")"
            }
        },
        sortname: "REPORT_DATE",
        columns: base_1["default"].columns,
        onPreBody: function (data) {
            if (data && data.length > 0) {
                chart(data);
            }
        }
    });
}
function chart(data) {
    var chart = window.echarts.init(document.getElementById("chart"));
    var years = [];
    var datajson = {};
    var datas = [];
    for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var year = fieldtools_1["default"].dateformat(item.REPORT_DATE, 'YYYY');
        var month = fieldtools_1["default"].dateformat(item.REPORT_DATE, 'MM');
        if (month != '12') {
            year = year + (month == "03" ? "Q1" : (month == "06" ? "Q2" : "Q3"));
        }
        var value = parseFloat(item.GOODWILL);
        if (!isNaN(value)) {
            years.push(year);
            datajson[year] = value;
        }
    }
    years.sort();
    var isd = false;
    var temp = years[years.length - 1];
    for (var i = 0; i < 4 && i < years.length; i++) {
        if (years[years.length - 1].indexOf('Q') > 0) {
            years.pop();
            isd = true;
        }
    }
    if (isd)
        years.push(temp); ///保留最后一年的最后一个报告期
    years = years.slice(-6);
    for (var i = 0; i < years.length; i++) {
        datas.push(datajson[years[i]]);
    }
    var option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (data) {
                var str = "";
                var date = data[0].axisValue;
                for (var i = 0; i < data.length; i++) {
                    if (!fieldtools_1["default"].isEmpty(data[i].value)) {
                        str += data[i].marker + '商誉' + ':' + fieldtools_1["default"].fieldfmt(data[i].value) + '<br/>';
                    }
                }
                return date + '<br/>' + str;
            }
        },
        grid: {
            top: '60',
            left: '5',
            right: '5',
            bottom: '5',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: years
        },
        legend: {
            data: ['商誉（元）'],
            right: '10'
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: function (value, index) {
                    return fieldtools_1["default"].fieldfmt(value, { num: 0 });
                }
            },
            splitLine: {
                lineStyle: { type: 'dashed' }
            }
        },
        series: [{
                name: '商誉（元）',
                data: datas,
                type: 'bar',
                barWidth: '50%',
                barMaxWidth: 50,
                itemStyle: { color: '#008fce' }
            }]
    };
    chart.setOption(option);
}
